import { Daycare } from '@/types/Daycare'
import { FunctionComponent, useState } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import EditClosingDay from './editClosingDay'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import { ClosingDay } from '@/types/ClosingDays'
import { useTranslation } from 'react-i18next'

interface EditClosingDayDialogProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    closingDay: ClosingDay
    closingDays?: ClosingDay[]
    daycare?: Daycare
    refetchAllEvents: () => Promise<void>
}

const EditClosingDayDialog: FunctionComponent<EditClosingDayDialogProps> = ({
    open,
    handleClose,
    daycareId,
    closingDay,
    closingDays,
    refetchAllEvents
}: EditClosingDayDialogProps) => {
    const { t } = useTranslation()

    const [title, setTitle] = useState<string>('')
    const [dateStart, setDateStart] = useState<string>('')

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('editClosingDay')} />
            <DialogBody>
                <EditClosingDay
                    create={false}
                    daycareId={daycareId}
                    handleClose={handleClose}
                    refetchAllEvents={refetchAllEvents}
                    closingDay={closingDay}
                    setTitle={setTitle}
                    title={title}
                    closingDays={closingDays}
                    dateStart={dateStart}
                    setDateStart={setDateStart}
                />
            </DialogBody>
        </Dialog>
    )
}

export default EditClosingDayDialog
